export default __webpack_public_path__ + "static/media/GF_POSTER_GROUP_01.b8f06b81.jpg";